import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'எங்கள் தேர்வு',
  bestPriceBadge: 'சிறந்த விலை',
  regulatedNotice: {
    prescriptionOnly: 'மருந்துச்சீட்டுடன் மட்டும்',
    professionalUse: 'தொழில்முறைப் பயன்பாட்டுக்கு',
    fromVeterinarian: 'உங்கள் கால்நடை மருத்துவரிடம் கிடைக்கும்',
    fromPharmacist: 'மருந்தாளுநரிடம் கிடைக்கும்',
    noOnlinePurchase: 'ஆன்லைனில் விற்கப்படுவதில்லை',
    professionalSupply: 'தொழில்முறை விநியோகஸ்தர்கள் மூலம் விற்கப்படுகிறது',
    whyNoLink: 'இந்தத் தயாரிப்பை நாங்கள் மதிப்பாய்வு செய்கிறோம், ஆனால் அதற்கு இணைப்பு தருவதில்லை.',
  },
};
